import { Avatar, Button, Form, message, Modal, Select, Tag } from "antd"
import CloseIcon from "../../../../components/icons/CloseIcon";
import EditIcon from "../../../../components/icons/EditIcon";
import Detailltem from "../../../Organization/components/Detailltem";
import { useEffect, useMemo, useState } from "react";
import BackIcon from "../../../../components/icons/BackIcon";
import SuccessComponent from "../../../components/BrandsPartnerComponents/SuccessComponent";
import { createBrandRequest, GetOrgBrands } from "../../../../API/endpoints/Discovery";
import { getColorByLetter } from "../../../../common/helpers";
import { GetBrandPreferences } from "../../../../API/endpoints/Brands";
import { STATUS_OPEN } from "../../../../constants/constants";
import { businessModelOptions, exclusivityTenureOptions, marketingInvestmentOptionsList, paymentTermsOptionsList, tradingTermsOptions } from "../../../../constants/dataConstants";

interface Props {
    open: boolean;
    onCancel: () => void;
    onSuccess: () => void;
    orgID: string;
}
const RequestMarketPartnerModal = (props: Props) => {
    const { open, orgID } = props;

    const [form] = Form.useForm();
    const [messaegApi, contextHolder] = message.useMessage()

    const [isEditCapabilities, setIsEditCapabilities] = useState(false);
    const [isEditKeyTerms, setIsEditKeyTerms] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const [brands, setBrands] = useState<any[]>([]);
    const [markets, setMarkets] = useState<any[]>([]);
    const [categories, setCategories] = useState<any[]>([]);


    const [capabilites, setCapabilities] = useState<any[]>([]);
    const [channels, setChannels] = useState<any[]>([]);


    const [marketLoading, setMarketLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    const [errors, setErrors] = useState<any>({});




    useEffect(() => {
        GetOrgBrands(orgID).then((res: any) => {
            setBrands(res?.data?.rows || []);
        }).catch((err) => {
            console.error('err', err);

        })
    }, [orgID])


    const onSubmit = () => {
        if (isEditCapabilities) {
            setIsEditCapabilities(false);
            return;
        }

        if (isEditKeyTerms) {
            setIsEditKeyTerms(false);
            return;
        }

        setSubmitLoading(true);
        form.validateFields().then((values: any) => {
            const req = {
                brand_id: values?.brand,
                market: values?.market,
                category: values?.category,
                sub_category: values?.subCategory,
                partner_capabilities: capabilitiesFiltered,
                partner_channels: channelsFiltered,
                partner_key_terms: {
                    acceptedBusinessModel: values?.acceptedBusinessModel,
                    tradingTerms: values?.tradingTerms,
                    exclusivityTenure: values?.exclusivityTenure,
                    marketingInvestment: values?.marketingInvestment,
                    paymentTerms: values?.paymentTerms
                },
                status: STATUS_OPEN
            }

            createBrandRequest(req).then((res: any) => {
                props.onSuccess()
                setSubmitLoading(false);
                setIsSuccess(true);
            }).catch((err) => {
                setSubmitLoading(false);
                console.error('err', err);
                messaegApi.error("Failed to sent request for partner. Please try again!");
            })

        }).catch((err) => {
            console.error(err);
            if (err?.errorFields && err?.errorFields?.length > 0) {
                setErrors(
                    err?.errorFields?.reduce((prev: any, item: any) => ({
                        ...prev,
                        [item?.name?.[0]]: item?.errors?.[0]
                    }), {})
                )
            }
            setSubmitLoading(false);
        })
    }



    const onCancel = () => {
        props?.onCancel()
        reset()
    }

    const reset = () => {
        form.resetFields();
        setIsEditCapabilities(false);
        setIsEditKeyTerms(false);
        setIsSuccess(false)
    }


    const selectedBrand = Form.useWatch("brand", form);
    const selectedCategory = Form.useWatch("category", form);
    const selectedMarket = Form.useWatch("market", form);

    const capabilitiesFiltered = Form.useWatch("capabilities", form);

    const channelsFiltered = Form.useWatch("channels", form);

    const acceptedBusinessModel = Form.useWatch("acceptedBusinessModel", form);
    const exclusivityTenure = Form.useWatch("exclusivityTenure", form);
    const marketingInvestment = Form.useWatch("marketingInvestment", form);
    const paymentTerms = Form.useWatch("paymentTerms", form);
    const tradingTerms = Form.useWatch("tradingTerms", form);


    useEffect(() => {
        form.resetFields([
            "market",
            "category",
            "subCategory"
        ]);

        if (selectedBrand) {
            setMarketLoading(true);
            const brand = brands?.find((item: any) => item?.id === selectedBrand)
            const categories = brand?.brand_categories || [];
            setCategories(categories);

            GetBrandPreferences(selectedBrand).then((res: any) => {
                const prefs = res?.data

                setMarkets(prefs?.market_preference?.map((item: any) => ({ label: item?.regions?.name, value: item?.region, ...item })) || []);
                setMarketLoading(false);
                const bPrefs = prefs?.brand_preference
                form.setFieldsValue({
                    acceptedBusinessModel: bPrefs?.engagement_model?.length > 0 ? bPrefs?.engagement_model[0] : '',
                    exclusivityTenure: bPrefs?.exclusivity_tenure || "",
                    marketingInvestment: bPrefs?.marketing_investments || "",
                    paymentTerms: bPrefs?.payment_terms || "",
                    tradingTerms: bPrefs?.trading_terms || ""
                });

            }).catch((err) => {
                setMarketLoading(false);
                console.error("unablde to fetch brand preferences");

            })

        } else {
            setMarkets([]);
            setCategories([]);
            form.resetFields([
                "engagement_model",
                "exclusivity_tenure",
                "marketing_investments",
                "payment_terms",
                "trading_terms"
            ]);
        }


    }, [selectedBrand, brands]);

    useEffect(() => {
        if (selectedMarket) {
            const capability: string[] = [];
            const channel: string[] = [];

            const market = markets?.find((item: any) => item?.value === selectedMarket);

            if (market?.regulatory_compliance) {
                capability.push("Regulatory Compliance")
            }
            if (market?.importation_clearance) {
                capability.push("Importation & Clearance")
            }

            if (market?.ambient_warehousing || market?.cold_and_frozen_warehousing || market?.ambient_warehousing) {
                capability.push("Warehousing")
            }

            if (market?.retail_distribution) {
                capability.push("Distribution")
            }
            if (market?.sales) {
                capability.push("Sales")
            }
            if (market?.marketing) {
                capability.push("Marketing")
            }


            if (market?.offline_retail) {
                channel.push("Offline Retail")
            }
            if (market?.online) {
                channel.push("Online")
            }
            if (market?.food_service) {
                channel.push("Food Service/Out of Home")
            }


            if (channel.length === 0) {
                channel.push("None")
            }

            setCapabilities(capability);
            setChannels(channel)

            form.setFieldsValue({
                capabilities: capability,
                channels: channel
            })
        } else {
            setCapabilities([]);
            setChannels([]);
            form.resetFields(["capabilities", "channels"]);
        }

    }, [selectedMarket, markets])


    const subCategories = useMemo(() => {
        form.resetFields(["subCategory"]);
        if (selectedCategory) {
            return categories
                ?.find((item: any) => item?.focus_category === selectedCategory)
                ?.sub_categories?.map((item: string) => ({ label: item, value: item })) || [];
        }

        return []

    }, [selectedCategory, categories]);





    const capabilityList = useMemo(() => {
        return capabilitiesFiltered?.map((item: string, index: number) => {
            return <Tag bordered={false} key={item}>{item}</Tag>
        })
    }, [capabilitiesFiltered])

    const channelsList = useMemo(() => {
        return channelsFiltered?.map((item: string, index: number) => {
            return <Tag bordered={false} key={item}>{item}</Tag>
        })
    }, [channelsFiltered])



    return (
        <Modal
            open={open}
            width={500}
            title={(
                isEditCapabilities ? (
                    <div className="flex items-center gap-[8px]">
                        <Button type="text" size="small" className="leading-[12px]" icon={<BackIcon />} onClick={() => setIsEditCapabilities(false)} />
                        <p className="text-[13px] font-[500] m-0">Edit Partner Capabilities & Channels</p>
                    </div>
                ) : (
                    isEditKeyTerms ? (
                        <div className="flex items-center gap-[8px]">
                            <Button type="text" size="small" className="leading-[12px]" icon={<BackIcon />} onClick={() => setIsEditKeyTerms(false)} />
                            <p className="text-[13px] font-[500] m-0">Edit Partner Key Terms</p>

                        </div>
                    ) : (
                        <div className="flex items-center justify-between">
                            <p className="text-[13px] font-[500] m-0">Request Market Partner</p>
                            <Button type="text" size="small" className="leading-[12px]" icon={<CloseIcon />} onClick={onCancel} />
                        </div>

                    )
                )

            )}
            closable={false}
            okText={isEditCapabilities || isEditKeyTerms ? "Save" : "Submit Request"}
            cancelButtonProps={{
                type: "text",
                hidden: isSuccess
            }}
            okButtonProps={{
                hidden: isSuccess,
                loading: submitLoading
            }}
            centered
            onCancel={onCancel}
            onOk={onSubmit}
        >
            {contextHolder}
            {isSuccess ? (
                <div className="flex flex-col items-center h-[70vh] justify-center">
                    <SuccessComponent
                        isPlain={true}
                        title="Request Submitted"
                        message={(
                            <p className="text-center">We'll match you with relevant partners based on your market, capabilities, and terms. You'll receive email notifications when potential partners are found.</p>
                        )
                        }
                    />
                    <Button type="text" onClick={onCancel}>Close</Button>
                </div>
            ) : (
                <div className="h-[70vh] overflow-auto overflow-scroll-bar pr-1">
                    <Form form={form} layout="vertical" requiredMark={false}>
                        <div className={isEditCapabilities || isEditKeyTerms ? "hidden" : "block"}>
                            <Form.Item
                                name={"brand"}
                                label="Select Brand"
                                rules={[{ required: true, message: "Brand required!" }]}
                            >
                                <Select
                                    placeholder="Select Brand"
                                    options={brands}
                                    fieldNames={{ label: "brand_name", value: "id" }}
                                    optionRender={(option: any) => {
                                        const user = option?.data || option;
                                        return (
                                            <div
                                                className="flex items-center justify-between gap-x-[12px]"
                                                key={user?.email}
                                            >
                                                <div className="flex items-center gap-x-[12px] flex-1">
                                                    <Avatar shape="square" size={"small"} style={getColorByLetter(user?.brand_name?.charAt(0))}>{user?.brand_name?.charAt(0)?.toUpperCase()}</Avatar>
                                                    <p className="m-0">{user?.brand_name}</p>
                                                </div>
                                            </div>
                                        );
                                    }}
                                    labelRender={(item: any) => {
                                        const brand = brands.find((b) => b.id === item.value);
                                        if (!brand) return item.label;

                                        return (
                                            <div className="flex items-center gap-x-[8px]">
                                                <Avatar
                                                    shape="square"
                                                    size="small"
                                                    style={getColorByLetter(brand.brand_name?.charAt(0))}
                                                >
                                                    {brand.brand_name?.charAt(0)?.toUpperCase()}
                                                </Avatar>
                                                <span>{brand.brand_name}</span>
                                            </div>
                                        );
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                name={"market"}
                                label="Select Market"
                                rules={[{ required: true, message: "Market required!" }]}
                            >
                                <Select
                                    placeholder="Select Market"
                                    options={markets}
                                    loading={marketLoading}
                                />
                            </Form.Item>
                            <Form.Item
                                name={"category"}
                                label="Category"
                                rules={[{ required: true, message: "Category required!" }]}
                            >
                                <Select
                                    placeholder="Select Category"
                                    options={categories}
                                    fieldNames={{ label: "focus_category", value: "focus_category" }}
                                />
                            </Form.Item>
                            <Form.Item
                                name={"subCategory"}
                                label="Sub Categories"
                                rules={[{ required: true, message: "Sub-categories required!" }]}
                            >
                                <Select
                                    placeholder="Select Sub-category"
                                    mode="multiple"
                                    options={subCategories}
                                />
                            </Form.Item>

                            {selectedMarket ? (
                                <div className="p-[16px] rounded-[8px] border border-[#E4E7EC] mt-[32px]">
                                    <div className="flex items-center justify-between mb-[24px]">
                                        <p className="text-[12px] font-[600] m-0">Partner Capabilities & Channels</p>
                                        <Button type="text" size="small" className="leading-[12px]" icon={<EditIcon />} onClick={() => setIsEditCapabilities(true)}>Edit</Button>
                                    </div>
                                    <p className="text-[12px] font-[500]">Capabilities</p>
                                    <div className="flex flex-wrap gap-y-[6px]">
                                        {capabilitiesFiltered?.length > 0 ? (
                                            capabilityList
                                        ) : (
                                            <p className="text-[10px] text-gray-500">No capabilites.</p>
                                        )}

                                    </div>
                                    <p className="text-[12px] font-[500] mt-[16px]">Channels</p>
                                    <div className="flex flex-wrap gap-y-[6px]">
                                        {channelsFiltered?.length > 0 ? (
                                            channelsList
                                        ) : (
                                            <p className="text-[10px] text-gray-500">No capabilites.</p>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}


                            {
                                selectedBrand ? (
                                    <div className="p-[16px] rounded-[8px] border border-[#E4E7EC] mt-[32px]">
                                        <div className="flex items-center justify-between mb-[24px]">
                                            <p className="text-[12px] font-[600] m-0">Key Terms</p>
                                            <Button type="text" size="small" className="leading-[12px]" icon={<EditIcon />} onClick={() => setIsEditKeyTerms(true)}>Edit</Button>
                                        </div>
                                        <div className="grid grid-cols-2 gap-[24px]">
                                            <Detailltem label="Accepted Business Models" value={acceptedBusinessModel} error={errors?.acceptedBusinessModel} />
                                            <Detailltem label="Trading Terms" value={tradingTerms} error={errors?.tradingTerms} />
                                            <Detailltem label="Minimum Exclusivity Tenure" value={exclusivityTenure} error={errors?.exclusivityTenure} />
                                            <Detailltem label="Preference on Marketing Investment" value={marketingInvestment} error={errors?.marketingInvestment} />
                                            <Detailltem label="Payment Terms" value={paymentTerms} error={errors?.paymentTerms} />
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )
                            }

                        </div>
                        <div className={isEditCapabilities ? "block" : "hidden"}>
                            <Form.Item
                                name={"capabilities"}
                                label="Capabilities"
                                rules={[{ required: true, message: "Capabilities required!" }]}
                            >
                                <Select
                                    placeholder="Select Capabilities"
                                    mode="multiple"
                                    options={capabilites?.map((item: string) => ({ label: item, value: item }))}
                                    value={capabilitiesFiltered}
                                />
                            </Form.Item>
                            <Form.Item
                                name={"channels"}
                                label="Channels"
                                rules={[{ required: true, message: "Channels required!" }]}
                            >
                                <Select
                                    placeholder="Select Channels"
                                    mode="multiple"
                                    options={channels?.map((item: string) => ({ label: item, value: item }))}
                                    value={channelsFiltered}
                                />
                            </Form.Item>
                        </div>
                        <div className={`grid grid-cols-2 gap-x-[16px] ${isEditKeyTerms ? "block" : "hidden"}`}>
                            <Form.Item
                                name={"acceptedBusinessModel"}
                                label="Accepted Business Models"
                                rules={[{ required: true, message: "Accepted Business Models required!" }]}
                            >
                                <Select
                                    placeholder="Select"
                                    options={businessModelOptions}
                                />
                            </Form.Item>
                            <Form.Item
                                name={"tradingTerms"}
                                label="Trading Terms"
                                rules={[{ required: true, message: "Trading Terms required!" }]}
                            >
                                <Select
                                    placeholder="Select"
                                    options={tradingTermsOptions}
                                />
                            </Form.Item>
                            <Form.Item
                                name={"exclusivityTenure"}
                                label="Minimum Exclusivity Tenure"
                                rules={[{ required: true, message: "Minimum Exclusivity Tenure required!" }]}
                            >
                                <Select
                                    placeholder="Select"
                                    options={exclusivityTenureOptions}
                                />
                            </Form.Item>
                            <Form.Item
                                name={"marketingInvestment"}
                                label="Marketing Investment"
                                rules={[{ required: true, message: "Marketing Investment required!" }]}
                            >
                                <Select
                                    placeholder="Select"
                                    options={marketingInvestmentOptionsList}
                                />
                            </Form.Item>
                            <Form.Item
                                name={"paymentTerms"}
                                label="Payment Terms"
                                rules={[{ required: true, message: "Payment Terms required!" }]}
                            >
                                <Select
                                    placeholder="Select"
                                    options={paymentTermsOptionsList}
                                />
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            )}

        </Modal>
    )
}

export default RequestMarketPartnerModal